export const loadingHistoricoConstants = {
  HISTORICO_LOADING_REQUEST: 'HISTORICO_LOADING_REQUEST',
  HISTORICO_LOADING_SUCCESS: 'HISTORICO_LOADING_SUCCESS',
  HISTORICO_LOADING_FAILURE: 'HISTORICO_LOADING_FAILURE',
};
